<p *ngIf="error" role="alert" class="text-danger">{{ error }}</p>
<tt-page *ngIf="page">
    <tt-card class="col-xs-12 sp-0"><tt-input ttLabel="travelbill_no" [ttModel]="page.travelbill_no" ttReadonly></tt-input></tt-card>
    <tt-sr-refund-list [items]="specifications" [viewId]="page.view_id" [travelBillToolbar]="true" [navigateRows]="true" (itemClick)="openItem($event)"></tt-sr-refund-list>
</tt-page>
